module.exports = __webpack_public_path__ + "img/maxresdefault.99b37aea.jpg";